import type { PreferredRegion } from '~/utils/geo';

import { parseRegionPreference, REGION_PREFERENCE_COOKIE } from '~/utils/geo';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

/**
 * The visitor's stored region preference — the source of truth for
 * preference-based geo routing (it always overrides the detected geo).
 *
 * A plain `useCookie`, not `useClusterCookie`: the preference must be readable
 * by both consumer clusters on the shared apex (see `REGION_PREFERENCE_COOKIE`).
 * The raw cookie is untrusted input, so reads are narrowed to a served region;
 * anything else reads as `null` (no preference).
 */
export const useRegionPreference = () => {
  const cookie = useCookie<string | null>(REGION_PREFERENCE_COOKIE, {
    maxAge: ONE_YEAR_SECONDS,
    sameSite: 'lax',
    secure: true,
    default: () => null,
  });

  return computed<PreferredRegion | null>({
    get: () => parseRegionPreference(cookie.value),
    set: (value) => {
      cookie.value = value;
    },
  });
};
